import { of as observableOf, Observable } from 'rxjs';

import { map } from 'rxjs/operators';
import { JobseekerLanguageModel } from '../models/jobseeker-language-model';
import { EducationLevelEnum } from '../models/education-level-enum';
import { JobseekerEducationModel } from '../models/jobseeker-education-model';
import { UserModel } from '../../../core/user-model.model';
import { PagingWrapper } from '../../../core/models/paging-wrapper';
import { UrlConfigContainer } from '../../../core/url-config';
import { AjaxDataServiceService } from '../../../core/ajax-data-service.service';
import { JobseekerFilterModel } from '../models/jobseeker-filter-model';
import { Injectable } from '@angular/core';
import { UrlConfigService } from '@hrra/core';
import { JobseekerModel } from '../models/jobseeker-model';
import { JobseekerWorkexperienceModel } from '../models/jobseeker-workexperience-model';
import { EmptyData } from '@admin/core/models/empty-data';
import { encode } from '../../../shared/value-utils';
import { PagingFilter } from '@admin/shared/models/paging-filter.model';
import { CommonLookupItem } from '@admin/shared/models/common-lookup-item.model';
import { OccupationCategorySelection } from '../models/occupation-category-selection';
import { GenericResult } from '@admin/shared/models/generic-result';
import { JobseekerGetResult } from '../models/Jobseeker-generic-result';
import {
  ExtendedJobseekerDetails,
  JobseekerModeratienViewModel,
} from '../models/jobseeker-moderation.model';
import { NewAjaxDataServiceService } from '@admin/core/new-ajax-data.service';
import { ApiResponse } from '@admin/core/api-response';

@Injectable()
export class JobseekerService {
  public getJobseekerMock() {
    let t = new JobseekerModel();

    t = t.fromObject({
      name: 'vasia',
      surname: 'pupkin',
    });

    return observableOf(t);
  }

  public getJobseeker(jobseekerId: number): Observable<JobseekerGetResult> {
    let url = this.urlService.format(this.urlService.urlConfig.api.data.jobseeker.get, {
      id: jobseekerId,
    });
    return this.ajax.getData(
      url,
      { jobseekerId: jobseekerId.toString() },
      JobseekerGetResult
    );
  }

  public getModerationJobseeker(
    jobseekerId: string
  ): Observable<ApiResponse<JobseekerModeratienViewModel>> {
    let url = this.urlService.format(
      this.urlService.urlConfig.api.data.jobseeker.getModerationJobseeker,
      { jobseekerId: jobseekerId }
    );
    return this.newAjax.getData(url);
  }

  public getModerationJobseekerCount(): Observable<
    ApiResponse<{ totalModerationCount: number }>
  > {
    return this.newAjax.getData(
      this.urlService.urlConfig.api.data.jobseeker.getModerationCount
    );
  }

  public getJobseekerDetails(jobseekerId: number): Observable<any> {
    let url = this.urlService.format(
      this.urlService.urlConfig.api.data.jobseeker.getJobseekerDetails,
      { jobseekerId: jobseekerId }
    );
    return this.newAjax.getData(url);
  }

  public approveJobseekerModeration(jobseekerModerationId, data) {
    return this.newAjax.postData(
      this.urlService.format(
        this.urlService.urlConfig.api.data.jobseeker.approveJobseekerModeration,
        { jobseekerModerationId: jobseekerModerationId }
      ),
      data
    );
  }

  public rejectJobseekerModeration(jobseekerModerationId: string, rejectMessage: string) {
    return this.newAjax.postData(
      this.urlService.format(
        this.urlService.urlConfig.api.data.jobseeker.rejectJobseekerModeration,
        { jobseekerModerationId: jobseekerModerationId }
      ),
      { JobseekerModerationId: jobseekerModerationId, RejectMessage: rejectMessage }
    );
  }

  public deleteJobseeker(jobseekerId: number) {
    return this.newAjax.postData(
      this.urlService.format(this.urlService.urlConfig.api.data.jobseeker.delete, {
        id: jobseekerId,
      }),
      {}
    );
  }

  public updateJobseekerPreferredLanguage(
    jobseekerId: number,
    preferredLanguage: string
  ) {
    let url = this.urlService.format(
      this.urlService.urlConfig.api.data.jobseeker.updarePreferredLanguage,
      { id: jobseekerId }
    );
    let data = {
      JobseekerId: jobseekerId,
      LanguageId: preferredLanguage,
    };
    return this.ajax.postData(url, data, EmptyData);
  }

  public saveJobseekerBasicInfo(jobseeker: JobseekerModel) {
    let url = this.urlService.format(
      this.urlService.urlConfig.api.data.jobseeker.basicInfo.save,
      { id: jobseeker.jobseekerId }
    );
    let data = {
      Name: jobseeker.name,
      Surname: jobseeker.surname,
      Email: jobseeker.email,
      Phone: jobseeker.phone,
      Phone2: jobseeker.phone2,
      Username: jobseeker.username,
      UpdateBasicInfo: true,
    };
    return this.ajax.postData(url, data, EmptyData);
  }

  public saveInternalEmployeeState(jobseeker: JobseekerModel) {
    let url = this.urlService.format(
      this.urlService.urlConfig.api.data.jobseeker.updateInternalEmployeeState,
      { id: jobseeker.jobseekerId }
    );
    let data = {
      IsInternalEmployee: jobseeker.isInternalEmployee,
    };

    return this.ajax.postData(url, data, EmptyData);
  }

  public saveJobseekerWorkExperience(
    jobseekerWorkExperience: JobseekerWorkexperienceModel,
    newFileName?: string
  ) {
    let workExperience = <any>{
      JobseekerWorkExperienceId:
        jobseekerWorkExperience.jobseekerWorkExperienceId,
      Employer: jobseekerWorkExperience.employer,
      PositionTitle: jobseekerWorkExperience.positionTitle, //TODO: reset on change required filled -> not required left value
      IsCurrent: jobseekerWorkExperience.isCurrent,
      DateFromYear: jobseekerWorkExperience.dateFromYear,
      DateFromMonth: jobseekerWorkExperience.dateFromMonth,
      DateToYear: jobseekerWorkExperience.dateToYear,
      DateToMonth: jobseekerWorkExperience.dateToMonth,
      Description: jobseekerWorkExperience.description,
      Attachment: jobseekerWorkExperience.attachment,
    };

    workExperience.OccupationCategories = [];

    jobseekerWorkExperience.categories.forEach((c) =>
      workExperience.OccupationCategories.push(c.category.occupationCategoryId)
    );

    if (newFileName != null) {
      workExperience.Attachment = { FileName: newFileName };
    }

    workExperience.Description = encode(workExperience.Description);

    let data = {
      JobseekerId: jobseekerWorkExperience.jobseekerId,
      UpdateWorkExperiences: true,
      WorkExperience: workExperience,
    };

    return this.ajax.postData(
      this.urlService.format(this.urlService.urlConfig.api.data.jobseeker.workExperience.save, {
        id: jobseekerWorkExperience.jobseekerId,
      }),
      data,
      EmptyData
    );
  }

  public SetWithouWorkExperience(jobseekerId: number) {
    return this.ajax.postData(
      this.urlService.format(
        this.urlService.urlConfig.api.data.jobseeker.workExperience.setWithoutExperience,
        { id: jobseekerId }
      ),
      null,
      EmptyData
    );
  }

  public deleteJobseekerWorkExperience(
    workExperience: JobseekerWorkexperienceModel
  ) {
    return this.ajax.postData(
      this.urlService.format(
        this.urlService.urlConfig.api.data.jobseeker.workExperience.delete,
        { id: workExperience.jobseekerId }
      ),
      { JobseekerWorkExperienceId: workExperience.jobseekerWorkExperienceId },
      EmptyData
    );
  }

  public deleteJobseekerEducation(education: JobseekerEducationModel) {
    return this.ajax.postData(
      this.urlService.format(this.urlService.urlConfig.api.data.jobseeker.education.delete, {
        id: education.jobseekerId,
      }),
      { jobseekerEducationId: education.jobseekerEducationId },
      EmptyData
    );
  }

  public saveJobseekerDetails(jobseeker: JobseekerModel) {
    let url = this.urlService.format(this.urlService.urlConfig.api.data.jobseeker.details.save, {
      id: jobseeker.jobseekerId,
    });

    let locations = jobseeker.extendedLocationPath.locations.filter(
      (c) => c.locationId != null
    );
    let ExtendedLocationId = null;
    if (locations.length > 0) {
      ExtendedLocationId = locations[locations.length - 1].locationId;
    }

    let data = {
      Gender: jobseeker.genderId,
      // City: jobseeker.cityId,
      ExtendedLocationId: ExtendedLocationId,
      Address: jobseeker.address,
      DateOfBirth: jobseeker.birthDate,
      DrivingLicenses: jobseeker.drivingLicenses.map((p) => p.drivingLicenceId),
      Photo: jobseeker.photoHref,
      UpdateDetails: true,
    };
    return this.ajax.postData(url, data, EmptyData);
  }

  public saveJobseekerEducation(
    jobseekerEducation: JobseekerEducationModel,
    newFileName?: string
  ) {
    let levelId = jobseekerEducation.educationLevel.educationLevelId;
    let isUniversity =
      levelId == EducationLevelEnum.Bachelor ||
      levelId == EducationLevelEnum.Master ||
      levelId == EducationLevelEnum.Doctorate;
    let url = this.urlService.format(
      this.urlService.urlConfig.api.data.jobseeker.education.save,
      { id: jobseekerEducation.jobseekerId }
    );

    let education = <any>{
      JobseekerEducationId: jobseekerEducation.jobseekerEducationId,
      EducationalInstitutionId:
        jobseekerEducation.educationalInstitution &&
        jobseekerEducation.educationalInstitution.educationalInstitutionId,
      EducationalProgramId:
        jobseekerEducation.educationalProgram &&
        jobseekerEducation.educationalProgram.educationalProgramId,
      EducationalProgramName:
        jobseekerEducation.educationalProgram != null &&
        jobseekerEducation.educationalProgram.name != undefined
          ? jobseekerEducation.educationalProgram.name
          : jobseekerEducation.educationalProgram,
      EducationLevelId: levelId,
      DateFromYear: jobseekerEducation.dateFromYear,
      DateFromMonth: jobseekerEducation.dateFromMonth,
      DateToYear: jobseekerEducation.dateToYear,
      DateToMonth: jobseekerEducation.dateToMonth,
      Institution:
        !isUniversity || jobseekerEducation.educationalInstitution == null
          ? jobseekerEducation.institution
          : jobseekerEducation.educationalInstitution.name != undefined
          ? jobseekerEducation.educationalInstitution.name
          : jobseekerEducation.educationalInstitution,
      Specialization: jobseekerEducation.specialization,
      Description: jobseekerEducation.description,
      Attachment: jobseekerEducation.attachment,
    };

    if (newFileName != null) {
      education.Attachment = { FileName: newFileName };
    }

    education.Description = encode(education.Description);

    if (
      education.EducationLevelId == EducationLevelEnum.IncompleteHighSchool ||
      education.EducationLevelId == EducationLevelEnum.HighSchool
    ) {
      education.Specialization = null;
    }

    let data = {
      JobseekerId: jobseekerEducation.jobseekerId,
      UpdateEducations: true,
      Education: education,
    };
    return this.ajax.postData(url, data, EmptyData);
  }

  public saveJobseekerLanguage(
    jobseekerLanguage: JobseekerLanguageModel,
    newFileName?: string
  ) {
    let url = this.urlService.format(
      this.urlService.urlConfig.api.data.jobseeker.language.save,
      { id: jobseekerLanguage.jobseekerId }
    );
    let language = <any>{
      JobseekerLanguageId: jobseekerLanguage.jobseekerLanguageId,
      WorldLanguageId:
        jobseekerLanguage.worldLanguage &&
        jobseekerLanguage.worldLanguage.worldLanguageId,
      LanguageProficiencyLevelId:
        jobseekerLanguage.languageProficiencyLevel &&
        jobseekerLanguage.languageProficiencyLevel.languageProficiencyLevelId,
      Attachment: jobseekerLanguage.attachment,
    };

    if (newFileName != null) {
      language.Attachment = { FileName: newFileName };
    }

    let data = {
      JobseekerId: jobseekerLanguage.jobseekerId,
      UpdateLanguages: true,
      Language: language,
    };

    return this.ajax.postData(url, data, EmptyData);
  }

  public DeleteUploadedDocument(jobseekerId: number, documentId: number) {
    let url = this.urlService.format(
      this.urlService.urlConfig.api.data.jobseeker.document.delete,
      { id: jobseekerId }
    );
    let data = {
      JobseekerId: jobseekerId,
      UpdateDocuments: true,
      document: {
        JobseekerDocumentId: documentId,
        IsDeleted: true,
      },
    };

    return this.ajax.postData(url, data, EmptyData);
  }

  public updateSubscription(
    jobseekerId: number,
    categories: OccupationCategorySelection[],
    localities: number[],
    digestOn: boolean
  ) {
    let data = {
      DailyDigestOn: digestOn,
      SelectedOccupationCategories: categories,
      SubscribedLocalities: localities,
    };
    return this.ajax.postData(
      this.urlService.format(this.urlService.urlConfig.api.data.jobseeker.subscription.update, {
        id: jobseekerId,
      }),
      data,
      EmptyData
    );
  }

  public listActiveEvents(): Observable<CommonLookupItem<any, any>[]> {
    return <Observable<CommonLookupItem<any, any>[]>>(
      this.ajax
        .getDataPaging(
          this.urlService.urlConfig.api.data.customer.events.list,
          null,
          CommonLookupItem
        )
        .pipe(map((r) => r.items))
    );
  }

  public listOldAndCurrentEvents(): Observable<CommonLookupItem<any, any>[]> {
    return <Observable<CommonLookupItem<any, any>[]>>(
      this.ajax
        .getDataPaging(
          this.urlService.urlConfig.api.data.jobseeker.event.listOldAndCurrent,
          null,
          CommonLookupItem
        )
        .pipe(map((r) => r.items))
    );
  }

  public registerOnEvent(jobseekerId: number, eventId: number) {
    return this.ajax.postData(
      this.urlService.format(this.urlService.urlConfig.api.data.jobseeker.event.register, {
        id: jobseekerId,
        eventId: eventId,
      }),
      EmptyData,
      EmptyData
    );
  }

  public listJobseeker(
    filter: PagingFilter<JobseekerFilterModel>
  ): Observable<PagingWrapper<JobseekerModel>> {
    return this.ajax.postDataPaging(
      this.urlService.urlConfig.api.data.jobseeker.list,
      filter.toObject(),
      JobseekerModel
    );
  }

  public getWorkExperienceAttachmentDownloadUrl(jobseekerId: number) {
    return this.urlService.format(
      this.urlService.urlConfig.api.data.jobseeker.workExperience.attachment.download,
      { id: jobseekerId }
    );
  }

  public getJobseekerDeleteUrl(jobseekerId: number) {
    return this.urlService.format(this.urlService.urlConfig.api.data.jobseeker.delete, {
      id: jobseekerId,
    });
  }

  public getEducationAttachmentDownloadUrl(
    jobseekerId: number,
    jobseekerEducationId: number
  ) {
    return this.urlService.format(
      this.urlService.urlConfig.api.data.jobseeker.education.attachment.download,
      { id: jobseekerId, educationId: jobseekerEducationId }
    );
  }

  public getLanguageAttachmentDownloadUrl(
    jobseekerId: number,
    jobseekerLanguageId: number
  ) {
    return this.urlService.format(
      this.urlService.urlConfig.api.data.jobseeker.language.attachment.download,
      { id: jobseekerId, languageId: jobseekerLanguageId }
    );
  }

  public getUploadedDocumentDownloadUrl(
    jobseekerId: number,
    jobseekerDocumentId: number
  ) {
    return this.urlService.format(
      this.urlService.urlConfig.api.data.jobseeker.document.download,
      { id: jobseekerId, documentId: jobseekerDocumentId }
    );
  }

  public getTemporaryPassword(jobseekerId: number) {
    let url = this.urlService.format(
      this.urlService.urlConfig.api.data.jobseeker.basicInfo.resetPassword,
      { id: jobseekerId }
    );
    return this.ajax.postData(url, {}, UserModel);
  }

  constructor(
    private newAjax: NewAjaxDataServiceService,
    private ajax: AjaxDataServiceService,
    private urlService: UrlConfigService<UrlConfigContainer>
  ) {}
}
